// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3Soh3","ranges":"BmiRanges_ranges__2mJfS"};